<smrts-dialog title="Escolher importação para desfazer" [hasFootnote]="true">

  <div class="content custom-table">
    <div class="wrapper">
      <p-floatLabel variant="on">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
          <input
            pInputText
            id="buscarLoteImportacao"
            (input)="dt.filterGlobal($any($event.target).value, 'contains')" />
        </p-iconField>
        <label for="buscarLoteImportacao">Buscar arquivo</label>
      </p-floatLabel>
    </div>

    <p-table #dt [value]="lotes" dataKey="id" selectionMode="single"
      (onRowSelect)="onLoteSelect($event)" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
      [globalFilterFields]="['nomeArquivo', 'dataCadastroFormatada', 'periodoFormatado', 'quantidadeLancamentos']">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="nomeArquivo">Arquivo<p-sortIcon field="nomeArquivo" /></th>
          <th pSortableColumn="dataCadastro">Importado em<p-sortIcon field="dataCadastro" /></th>
          <th pSortableColumn="dataInicial">Período dos lançamentos<p-sortIcon field="dataInicial" /></th>
          <th pSortableColumn="quantidadeLancamentos">Lançamentos<p-sortIcon field="quantidadeLancamentos" /></th>
        </tr>
      </ng-template>
      <ng-template #body let-lote let-rowIndex="rowIndex">
        <tr [pSelectableRow]="lote" [pSelectableRowIndex]="rowIndex" class="table-row">
          <td>{{ lote.nomeArquivo }}</td>
          <td>{{ lote.dataCadastro | date:'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ lote.dataInicial | date:'dd/MM/yyyy' }} a {{ lote.dataFinal | date:'dd/MM/yyyy' }}</td>
          <td>{{ lote.quantidadeLancamentos }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">Não há importações de cartão para desfazer nesta conta.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="undefined">
      Cancelar
    </button>
  </div>
</smrts-dialog>
